import React, { useEffect, useRef } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Grid, Input, Line } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import useLoading from 'hooks/useLoading'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import { IContractTypeParams } from 'services/NGT/ContractsParams'
import { COLORS, SPACING } from 'utils'
import * as Yup from 'yup'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './EditContractTypeModal.style'

interface IEditContractTypeModal {
  showModal: boolean
  toggleModal: () => void
  handleSubmitUpdate: any
  contractTypesData: IContractTypeParams
}

const schema = Yup.object({
  dsTipoContrato: Yup.string().required('Tipo contrato é obrigátorio')
})

const EditContractTypeModal: React.FC<IEditContractTypeModal> = ({
  showModal,
  toggleModal,
  handleSubmitUpdate,
  contractTypesData
}) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm<IContractTypeParams>({
    resolver: yupResolver(schema)
  })

  const { loading, msgErro, setLoading } = useLoading()

  useEffect(() => {
    setValue('dsTipoContrato', contractTypesData?.dsTipoContrato)
  }, [contractTypesData])

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showModal}
      onClose={toggleModal}
      width={'md'}
    >
      <FormDialog
        onSubmit={handleSubmit((data) => {
          handleSubmitUpdate({
            ...data,
            idTipoContrato: contractTypesData?.idTipoContrato
          })
          reset()
          resetModalState(draggableReference)
        })}
      >
        <Line />
        <DialogTitleStyled>Editar Tipo Contrato SAP</DialogTitleStyled>
        <DialogContentStyled>
          <Grid
            gridCols="1fr 3fr 1fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
          >
            <Input
              label="Código"
              formValue="idTipoContrato"
              required
              value={contractTypesData?.idTipoContrato}
              disabled
            />
            <Input
              control={control}
              errors={errors}
              label="Tipo Contrato SAP"
              placeholder="Tipo Contrato SAP"
              formValue="dsTipoContrato"
              defaultValue={contractTypesData?.dsTipoContrato}
              maxLength={20}
              required
            />
          </Grid>
          <SuccessModal
            open={loading === 'error'}
            message={msgErro}
            type="error"
            hideButtonCancel
            handleConfirm={() => setLoading('idle')}
            txtButtonConfirm="Voltar"
          />
        </DialogContentStyled>

        <DialogActionsStyled>
          <Button
            text="Voltar"
            variantButton="outlined"
            backgroundColor={COLORS.white}
            textColor={COLORS.black}
            marginRight={SPACING.spacing20}
            marginBottom={SPACING.spacing15}
            borderColor={COLORS.black}
            onClick={() => {
              toggleModal()
              resetModalState(draggableReference)
              reset()
            }}
          />
          <Button
            marginRight={SPACING.spacing20}
            marginBottom={SPACING.spacing15}
            text="Salvar"
            type="submit"
          />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default EditContractTypeModal
